import {
  Autocomplete,
  AutocompleteContent,
  AutocompleteEmpty,
  AutocompleteInput,
  AutocompleteItem,
  AutocompleteList,
} from '@crono-one/design-system';
import FormField from 'components/CreationForms/base/FormField';
import useAccountIndustries from 'hooks/services/account/useAccountIndustries';
import { useDebouncedValue } from 'hooks/useDebouncedValue';
import { useId } from 'react';

const EMPTY_INDUSTRIES: string[] = [];

export interface IndustryFieldProps {
  label: string;
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (value: string) => void;
}

/** A company's industry: free text, with the known industries matching it suggested below. */
const IndustryField = ({
  label,
  placeholder,
  required,
  value,
  onChange,
}: IndustryFieldProps) => {
  const id = useId();
  const searchText = useDebouncedValue(value, 200);
  const { data } = useAccountIndustries({
    limit: 25,
    offset: 0,
    text: searchText,
  });
  const industries = data?.data.data ?? EMPTY_INDUSTRIES;

  return (
    <FormField label={label} required={required} fieldId={id}>
      <Autocomplete
        items={industries}
        value={value}
        onValueChange={(next) => onChange(next ?? '')}
      >
        <AutocompleteInput id={id} dsSize="sm" placeholder={placeholder} />
        <AutocompleteContent>
          <AutocompleteEmpty>No industries found</AutocompleteEmpty>
          <AutocompleteList>
            {(industry: string) => (
              <AutocompleteItem key={industry} value={industry}>
                {industry}
              </AutocompleteItem>
            )}
          </AutocompleteList>
        </AutocompleteContent>
      </Autocomplete>
    </FormField>
  );
};

export default IndustryField;
